import { Info } from "lucide-react";
import styles from "./analytics.module.scss";

function formatDuration(milliseconds) {
    if (milliseconds == null || Number.isNaN(Number(milliseconds))) {
        return "—";
    }

    const totalSeconds = Math.round(Number(milliseconds) / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
        return `${hours}h ${minutes}min`;
    }

    if (minutes > 0) {
        return `${minutes}min ${seconds}s`;
    }

    return `${seconds}s`;
}

function formatValue(value, format) {
    if (value == null || value === 0) {
        return "-";
    }

    switch (format) {
        case "duration":
            return formatDuration(value);

        case "number":
            return new Intl.NumberFormat("fr-FR").format(Number(value));

        default:
            return value;
    }
}

function SmallerDataItem({ label, data, info, format, disabled }) {
    return (
        <div className={styles.smallerDataItem}>
            <div className={styles.top}>
                <p className={styles.label}>{label}</p>

                {info && (
                    <div className={styles.infoContainer}>
                        <Info className={styles.icon} />
                        <p className={styles.tooltip}>{info}</p>
                    </div>
                )}
            </div>

            <p className={`${styles.value} ${disabled ? styles.textDisabled : ''}`}>
                {formatValue(data, format)}
            </p>
        </div>
    );
}

export default SmallerDataItem;
